<div class="peer-chats">
  <div class="head">
    <div>
      <h3>Member-to-member chats</h3>
      <p class="sub">{{ data.title }}</p>
    </div>
    <button mat-stroked-button (click)="close()">Close</button>
  </div>

  <div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>
  <div class="notice bad" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && !error">
    <p class="sub count" *ngIf="rows.length">
      {{ rows.length }} chat{{ rows.length === 1 ? '' : 's' }} between two members of this space ·
      {{ replied }} got a reply<span *ngIf="unanswered"> · {{ unanswered }} nobody answered</span>
    </p>

    <ul class="chats" *ngIf="rows.length">
      <li *ngFor="let c of rows" [class.unanswered]="!c.replied">
        <div class="pair">
          <ng-container *ngFor="let p of c.people; let i = index">
            <span class="sep" *ngIf="i">and</span>
            <span class="who">
              <app-person-link [uid]="p.uid" [name]="p.name"></app-person-link>
              <span class="meta">
                {{ p.messages }} message{{ p.messages === 1 ? '' : 's' }}<span *ngIf="p.started"> · started it</span>
              </span>
            </span>
          </ng-container>
        </div>
        <div class="facts">
          <span class="pill" [class.good]="c.replied">{{ c.replied ? 'Replied' : 'No reply' }}</span>
          <span class="meta">
            {{ c.messages }} message{{ c.messages === 1 ? '' : 's' }} ·
            first {{ ago(c.firstMessageAt) }} · last {{ ago(c.lastMessageAt) }}
          </span>
        </div>
      </li>
    </ul>

    <p class="sub" *ngIf="!rows.length">
      No two members of this space have ever written to each other.
    </p>

    <p class="sub note">
      Who and when only — no message is read, here or on the server.
    </p>
  </ng-container>
</div>
